import { useEffect } from 'react';
import type { Editor } from '@tiptap/react';
import { useAskSidebar, type PageType } from '../contexts/AskSidebarContext';

interface RegisterAskContextOptions {
  pageType: PageType;
  caseId?: string;
  reportId?: string;
  editor?: Editor | null;
  editorSelectedText?: string | null;
}

/**
 * Hook for pages to register their context with the Ask sidebar.
 * On unmount, resets context to 'other' (which hides the sidebar).
 */
export function useRegisterAskContext({
  pageType,
  caseId,
  reportId,
  editor,
  editorSelectedText,
}: RegisterAskContextOptions) {
  const { setPageContext } = useAskSidebar();

  useEffect(() => {
    setPageContext({
      pageType,
      caseId: caseId || null,
      reportId: reportId || null,
      editor: editor || null,
      editorSelectedText: editorSelectedText || null,
    });
  }, [pageType, caseId, reportId, editor, editorSelectedText, setPageContext]);

  // Cleanup: reset context when page unmounts
  useEffect(() => {
    return () => {
      setPageContext({
        pageType: 'other',
        caseId: null,
        reportId: null,
        editor: null,
        editorSelectedText: null,
      });
    };
  }, [setPageContext]);
}
